export default __webpack_public_path__ + "static/2k_earth_daymap-acb89a97c1d88eecb75434bfb46213b7.jpg";